import { Typography, Button } from "@mui/material";
import { positions } from "@mui/system";
import React from "react";
import "./GetInTouch.css";

function GetInTouch() {

  
  return (
    <div className="final-section" id="say-hello">
      <div></div>
      <div className="middle-section">
        <Typography variant="h4">Get In Touch</Typography>
        <Typography variant="p" sx={{ width: "90%" }} align="center">
          my inbox is always open. Whether you have a question or just want to
          say hi, I’ll try my best to get back to you!
        </Typography>
        <div>
          <a
            href="https://wa.me/7435894727"
            style={{ textDecoration: "none" }}
            target="__blank">
            <Button variant="outlined" sx={{ width: "200px", height: "60px" }}>
              Say Hello
            </Button>
          </a>
        </div>
      </div>
      <div></div>

      <Typography variant="h6"> Love Yourself 🌟</Typography>
      <Typography
        variant="p"
        sx={{ margin: "30px", fontSize: "0.7rem", color: "gray" }}>
        {" "}
        Designed and Built by @Divyesh Vyas
      </Typography>
    </div>
  );
}

export default GetInTouch;
